// ========== 技能数据库 (32个技能) ==========
export const SKILLS_DB = {
  // === 剑魂 ===
  sword_3hit_slash: { id:'sword_3hit_slash', name:'三段斩', icon:'⚡', type:'quick', cls:'sword',
    desc:'迅捷三连斩，每段造成1.5倍攻击伤害', cost:12, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:1.5,hits:3}, effects:{},
    upgraded:{dmg:{mult:1.5,hits:5},cost:15,name:'五段斩',desc:'极速五连斩，风卷残云般的连续攻击'} },
  sword_draw_cut: { id:'sword_draw_cut', name:'拔刀斩', icon:'💫', type:'power', cls:'sword',
    desc:'凝聚剑气瞬间拔刀，2.2倍伤害+20%暴击率', cost:18, cd:2, unlockLv:5, upgradeLv:30,
    dmg:{mult:2.2,critBonus:0.20}, effects:{},
    upgraded:{dmg:{mult:2.5,critBonus:0.30},cost:22,name:'极·拔刀斩',desc:'剑气纵横，爆裂一击'} },
  sword_rising_counter: { id:'sword_rising_counter', name:'流心·升', icon:'🛡️', type:'utility', cls:'sword',
    desc:'格挡反击：免疫本回合伤害并造成2.0倍反击', cost:20, cd:3, unlockLv:10, upgradeLv:45,
    dmg:{mult:2.0}, effects:{shield:1},
    upgraded:{dmg:{mult:2.5,critBonus:1.0},cost:24,effects:{shield:1},name:'流心·极',desc:'完美格挡后必定暴击反击'} },
  sword_ultimate: { id:'sword_ultimate', name:'极·鬼剑术', icon:'🌟', type:'ultimate', cls:'sword',
    desc:'终极奥义！4.0倍伤害，完全无视防御', cost:35, cd:5, unlockLv:20, upgradeLv:50,
    dmg:{mult:4.0,ignoreDef:true}, effects:{},
    upgraded:{dmg:{mult:5.0,ignoreDef:true,critBonus:1.0},cost:38,name:'极·鬼剑术·暴风式',desc:'万剑归宗，毁灭一击'} },

  // === 狂战士 ===
  berserk_mountain: { id:'berserk_mountain', name:'崩山击', icon:'💥', type:'quick', cls:'berserk',
    desc:'以血换伤，造成2.0倍伤害并消耗10HP', cost:10, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:2.0}, effects:{selfDmg:10},
    upgraded:{dmg:{mult:2.5},effects:{selfDmg:10},cost:12,name:'崩山裂地斩',desc:'大地为之崩裂的强力一击'} },
  berserk_bloodrage: { id:'berserk_bloodrage', name:'嗜血', icon:'🩸', type:'utility', cls:'berserk',
    desc:'激发血气，+5攻击+2防御持续3回合(消耗20HP)', cost:10, cd:3, unlockLv:5, upgradeLv:30,
    dmg:{mult:0}, effects:{selfDmg:20,buff:[{stat:'atk',val:5,dur:3},{stat:'def',val:2,dur:3}]},
    upgraded:{dmg:{mult:0},effects:{selfDmg:20,buff:[{stat:'atk',val:8,dur:3},{stat:'def',val:4,dur:3}]},cost:12,name:'血之狂暴',desc:'狂战士的终极战斗姿态'} },
  berserk_blood_burst: { id:'berserk_blood_burst', name:'血气爆发', icon:'🔥', type:'power', cls:'berserk',
    desc:'HP越低伤害越高（基础2.5x，HP每低10%+0.15x，最高4.0x）', cost:22, cd:2, unlockLv:10, upgradeLv:45,
    dmg:{mult:2.5,hpScaling:{perPct:0.10,bonusPerPct:0.15,maxMult:4.0}}, effects:{},
    upgraded:{dmg:{mult:3.0,hpScaling:{perPct:0.10,bonusPerPct:0.18,maxMult:4.8}},cost:25,name:'血气之刃',desc:'以血为刃，斩断一切'} },
  berserk_ultimate: { id:'berserk_ultimate', name:'魔狱血刹', icon:'👹', type:'ultimate', cls:'berserk',
    desc:'3.5倍伤害+50%生命偷取', cost:30, cd:4, unlockLv:20, upgradeLv:50,
    dmg:{mult:3.5}, effects:{lifesteal:0.50},
    upgraded:{dmg:{mult:4.2},effects:{lifesteal:0.70,overflowShield:1},cost:35,name:'血魔·弑天',desc:'吸取敌人生命化为己用'} },

  // === 鬼泣 ===
  ghost_slash: { id:'ghost_slash', name:'鬼斩', icon:'🌑', type:'quick', cls:'ghost',
    desc:'暗黑斩击，2.0倍伤害+30%诅咒敌人(-3防御2回合)', cost:15, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:2.0}, effects:{curse:{chance:0.30,def:-3,dur:2}},
    upgraded:{dmg:{mult:2.2},effects:{curse:{chance:0.40,def:-4,dur:2}},cost:18,name:'鬼斩·狂暴',desc:'鬼神之力加持的黑暗斩击'} },
  ghost_ice_saya: { id:'ghost_ice_saya', name:'冰霜之萨亚', icon:'❄️', type:'utility', cls:'ghost',
    desc:'召唤冰霜鬼神，1.8倍伤害+冰冻1回合', cost:20, cd:3, unlockLv:5, upgradeLv:30,
    dmg:{mult:1.8}, effects:{freeze:1},
    upgraded:{dmg:{mult:2.0},effects:{freeze:2},cost:24,name:'冰晶之萨亚',desc:'极寒冰狱，冻结一切'} },
  ghost_tombstone: { id:'ghost_tombstone', name:'墓碑三绝阵', icon:'🪦', type:'power', cls:'ghost',
    desc:'随机3-5段×1.2倍攻击（总伤3.6-6.0x）', cost:25, cd:3, unlockLv:10, upgradeLv:45,
    dmg:{mult:1.2,hits:[3,5]}, effects:{},
    upgraded:{dmg:{mult:1.4,hits:[4,6]},cost:28,name:'鬼神墓碑阵',desc:'无尽墓碑从天而降'} },
  ghost_ultimate: { id:'ghost_ultimate', name:'第七鬼神', icon:'💀', type:'ultimate', cls:'ghost',
    desc:'3.5倍伤害，目标HP低于20%时即死', cost:35, cd:5, unlockLv:20, upgradeLv:50,
    dmg:{mult:3.5}, effects:{execute:{hpPct:0.20}},
    upgraded:{dmg:{mult:4.0},effects:{execute:{hpPct:0.30}},cost:38,name:'鬼神诏令',desc:'邪神之怖拉修降临'} },

  // === 阿修罗 ===
  asura_wave_burst: { id:'asura_wave_burst', name:'波动爆发', icon:'🌊', type:'quick', cls:'asura',
    desc:'释放波动之力，造成2.0倍伤害', cost:15, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:2.0}, effects:{},
    upgraded:{dmg:{mult:2.3},effects:{bonusHit:{chance:0.25,mult:0.5}},cost:17,name:'波动爆发·极',desc:'蓄力波动，追加额外打击'} },
  asura_killing_intent: { id:'asura_killing_intent', name:'杀意波动', icon:'👁️', type:'utility', cls:'asura',
    desc:'释放杀意气场，+3攻击+3防御持续3回合', cost:18, cd:3, unlockLv:5, upgradeLv:30,
    dmg:{mult:0}, effects:{buff:[{stat:'atk',val:3,dur:3},{stat:'def',val:3,dur:3}]},
    upgraded:{dmg:{mult:0},effects:{buff:[{stat:'atk',val:5,dur:3},{stat:'def',val:5,dur:3}]},cost:20,name:'杀意波动·强化',desc:'杀意笼罩战场'} },
  asura_immobile_king: { id:'asura_immobile_king', name:'不动明王阵', icon:'🕉️', type:'power', cls:'asura',
    desc:'2.5倍伤害+晕眩敌人1回合', cost:22, cd:3, unlockLv:10, upgradeLv:45,
    dmg:{mult:2.5}, effects:{stun:1},
    upgraded:{dmg:{mult:2.8},effects:{stun:2},cost:26,name:'不动明王阵·极',desc:'绝对压制，无法动弹'} },
  asura_ultimate: { id:'asura_ultimate', name:'暗天波动眼', icon:'🔮', type:'ultimate', cls:'asura',
    desc:'3.2倍伤害+回复20HP', cost:30, cd:4, unlockLv:20, upgradeLv:50,
    dmg:{mult:3.2}, effects:{heal:20},
    upgraded:{dmg:{mult:3.8},effects:{heal:30,cleanse:true},cost:34,name:'雷神之息',desc:'天雷降世，清除一切负面'} },

  // === 漫游者 ===
  ranger_eagle: { id:'ranger_eagle', name:'双鹰回旋', icon:'🦅', type:'quick', cls:'ranger',
    desc:'双枪连射，2段×1.2倍伤害（共2.4x）', cost:14, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:1.2,hits:2}, effects:{},
    upgraded:{dmg:{mult:1.3,hits:3},cost:16,name:'三鹰回旋',desc:'三枪齐射，弹幕密布'} },
  ranger_mobile_shot: { id:'ranger_mobile_shot', name:'移动射击', icon:'🏃', type:'utility', cls:'ranger',
    desc:'边跑边射，3段×0.8倍无视防御（共2.4x真伤）', cost:18, cd:2, unlockLv:5, upgradeLv:30,
    dmg:{mult:0.8,hits:3,ignoreDef:true}, effects:{},
    upgraded:{dmg:{mult:1.0,hits:4,ignoreDef:true},cost:20,name:'枪舞',desc:'死亡之舞，子弹风暴'} },
  ranger_headshot: { id:'ranger_headshot', name:'爆头一击', icon:'💀', type:'power', cls:'ranger',
    desc:'精准爆头！3.0倍伤害+30%额外暴击率', cost:22, cd:2, unlockLv:10, upgradeLv:45,
    dmg:{mult:3.0,critBonus:0.30}, effects:{},
    upgraded:{dmg:{mult:3.5,critBonus:0.40,critMult:2.0},cost:25,name:'致命射击',desc:'一击毙命的精准狙击'} },
  ranger_ultimate: { id:'ranger_ultimate', name:'疯狂屠戮', icon:'🔫', type:'ultimate', cls:'ranger',
    desc:'随机4-6段×1.2倍（总伤4.8-7.2x）', cost:35, cd:5, unlockLv:20, upgradeLv:50,
    dmg:{mult:1.2,hits:[4,6]}, effects:{},
    upgraded:{dmg:{mult:1.3,hits:[5,7]},cost:38,name:'血舞祭',desc:'无尽弹雨，血色盛宴'} },

  // === 枪炮师 ===
  launcher_laser: { id:'launcher_laser', name:'激光炮', icon:'⚡', type:'quick', cls:'launcher',
    desc:'穿透激光，2.5倍伤害无视防御', cost:20, cd:2, unlockLv:1, upgradeLv:15,
    dmg:{mult:2.5,ignoreDef:true}, effects:{},
    upgraded:{dmg:{mult:3.0,ignoreDef:true},cost:22,name:'蓄电激光炮',desc:'蓄满能量的毁灭光束'} },
  launcher_flame: { id:'launcher_flame', name:'聚焦喷火器', icon:'🔥', type:'utility', cls:'launcher',
    desc:'2.0倍伤害+灼烧5伤害×3回合', cost:22, cd:3, unlockLv:5, upgradeLv:30,
    dmg:{mult:2.0}, effects:{burn:{dmg:5,dur:3}},
    upgraded:{dmg:{mult:2.3},effects:{burn:{dmg:8,dur:3}},cost:25,name:'等离子放射器',desc:'高温等离子烈焰'} },
  launcher_quantum: { id:'launcher_quantum', name:'X-1压缩量子炮', icon:'💥', type:'power', cls:'launcher',
    desc:'3.0倍伤害+破甲(-5防御2回合)', cost:26, cd:3, unlockLv:10, upgradeLv:45,
    dmg:{mult:3.0}, effects:{debuff:[{stat:'def',val:-5,dur:2}]},
    upgraded:{dmg:{mult:3.5},effects:{debuff:[{stat:'def',val:-7,dur:2}]},cost:30,name:'X-2毁灭量子炮',desc:'粉碎一切防御'} },
  launcher_ultimate: { id:'launcher_ultimate', name:'卫星射线', icon:'🛰️', type:'ultimate', cls:'launcher',
    desc:'3.8倍+8次激光(每次0.3x)', cost:38, cd:5, unlockLv:20, upgradeLv:50,
    dmg:{mult:3.8}, effects:{bonusHits:{count:8,mult:0.3}},
    upgraded:{dmg:{mult:4.5},effects:{bonusHits:{count:10,mult:0.35}},cost:42,name:'卫星定位·毁灭',desc:'太空卫星锁定毁灭打击'} },

  // === 圣骑士 ===
  crusader_holy_cross: { id:'crusader_holy_cross', name:'圣光十字', icon:'✝️', type:'quick', cls:'crusader',
    desc:'1.8倍伤害+回复15HP', cost:16, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:1.8}, effects:{heal:15},
    upgraded:{dmg:{mult:2.0},effects:{heal:20},cost:18,name:'圣光十字·强化',desc:'更强的圣光治愈'} },
  crusader_blessing: { id:'crusader_blessing', name:'荣誉祝福', icon:'🙏', type:'utility', cls:'crusader',
    desc:'神圣祝福：+4攻击+4防御持续3回合', cost:20, cd:3, unlockLv:5, upgradeLv:30,
    dmg:{mult:0}, effects:{buff:[{stat:'atk',val:4,dur:3},{stat:'def',val:4,dur:3}]},
    upgraded:{dmg:{mult:0},effects:{buff:[{stat:'atk',val:6,dur:3},{stat:'def',val:6,dur:3}]},cost:22,name:'勇气祝福',desc:'圣光护佑，无坚不摧'} },
  crusader_holy_shield: { id:'crusader_holy_shield', name:'圣光守护', icon:'🛡️', type:'utility', cls:'crusader',
    desc:'神圣护盾：免疫所有伤害持续1回合', cost:25, cd:4, unlockLv:10, upgradeLv:45,
    dmg:{mult:0}, effects:{invincible:1},
    upgraded:{dmg:{mult:0},effects:{invincible:2,reflect:0.30},cost:28,name:'圣光之盾',desc:'神圣护盾，反伤来犯之敌'} },
  crusader_ultimate: { id:'crusader_ultimate', name:'天启之珠', icon:'☀️', type:'ultimate', cls:'crusader',
    desc:'2.5倍伤害+HP全回复+清除所有负面', cost:35, cd:5, unlockLv:20, upgradeLv:50,
    dmg:{mult:2.5}, effects:{healPct:1.0,cleanse:true},
    upgraded:{dmg:{mult:3.0},effects:{healPct:1.0,cleanse:true,hot:{heal:10,dur:3}},cost:38,name:'圣愈之风',desc:'神圣之光照耀大地'} },

  // === 混沌 ===
  monk_demon_hand: { id:'monk_demon_hand', name:'恶魔之手', icon:'👿', type:'quick', cls:'monk',
    desc:'2.0倍伤害+25%生命偷取', cost:18, cd:1, unlockLv:1, upgradeLv:15,
    dmg:{mult:2.0}, effects:{lifesteal:0.25},
    upgraded:{dmg:{mult:2.2},effects:{lifesteal:0.35},cost:20,name:'恶魔之握',desc:'更强的恶魔之力吸取'} },
  monk_dark_cut: { id:'monk_dark_cut', name:'黑暗切割', icon:'🗡️', type:'power', cls:'monk',
    desc:'2.5倍伤害，无视50%防御', cost:22, cd:2, unlockLv:5, upgradeLv:30,
    dmg:{mult:2.5,ignoreDefPct:0.50}, effects:{},
    upgraded:{dmg:{mult:2.8,ignoreDefPct:0.70},cost:25,name:'次元斩',desc:'撕裂空间的黑暗斩击'} },
  monk_hell_gate: { id:'monk_hell_gate', name:'地狱之门', icon:'🚪', type:'utility', cls:'monk',
    desc:'2.2倍伤害+召唤恶魔(2回合，每回合0.2xATK)', cost:28, cd:4, unlockLv:10, upgradeLv:45,
    dmg:{mult:2.2}, effects:{summon:{dur:2,atkPct:0.20}},
    upgraded:{dmg:{mult:2.5},effects:{summon:{dur:3,atkPct:0.30}},cost:30,name:'地狱之门·终',desc:'恶魔大军降临'} },
  monk_ultimate: { id:'monk_ultimate', name:'混沌破晓', icon:'🌅', type:'ultimate', cls:'monk',
    desc:'3.5倍伤害+永久+2攻击', cost:32, cd:4, unlockLv:20, upgradeLv:50,
    dmg:{mult:3.5}, effects:{permBuff:{stat:'atk',val:2}},
    upgraded:{dmg:{mult:4.0},effects:{permBuff:{stat:'atk',val:3},bonusDmg:{hpPct:0.15}},cost:36,name:'混沌破晓·终焉',desc:'混沌之力彻底觉醒'} },

  // ========== 觉醒技能 (Lv.50) ==========
  sword_awaken: { id:'sword_awaken', name:'极·鬼剑术·暴风式', icon:'⚔️', type:'awaken', cls:'sword',
    desc:'万剑归宗！5.0倍伤害，无视防御，2回合ATK+30%', cost:50, cd:8, unlockLv:50,
    dmg:{mult:5.0,ignoreDef:true}, effects:{buff:[{stat:'atk',val:0.30,dur:2,relative:true}]} },
  berserk_awaken: { id:'berserk_awaken', name:'血魔·弑天', icon:'👹', type:'awaken', cls:'berserk',
    desc:'消耗20%HP造成5.5倍伤害，伤害60%转化为治疗', cost:50, cd:8, unlockLv:50,
    dmg:{mult:5.5}, effects:{selfDmgPct:0.20,lifesteal:0.60} },
  ghost_awaken: { id:'ghost_awaken', name:'第七鬼神·邪神之怖拉修', icon:'💀', type:'awaken', cls:'ghost',
    desc:'4.5倍伤害+HP<20%即死+诅咒2回合', cost:50, cd:8, unlockLv:50,
    dmg:{mult:4.5}, effects:{execute:{hpPct:0.20},curse:{chance:1.0,def:-5,dur:2}} },
  asura_awaken: { id:'asura_awaken', name:'暗天波动眼·终幕', icon:'🔮', type:'awaken', cls:'asura',
    desc:'4.5倍伤害+晕眩2回合+清除自身负面', cost:50, cd:8, unlockLv:50,
    dmg:{mult:4.5}, effects:{stun:2,cleanse:true} },
  ranger_awaken: { id:'ranger_awaken', name:'死亡左轮', icon:'🔫', type:'awaken', cls:'ranger',
    desc:'5.0倍伤害+必定暴击+无视30%防御', cost:50, cd:8, unlockLv:50,
    dmg:{mult:5.0,critBonus:1.0,ignorePct:0.30}, effects:{} },
  launcher_awaken: { id:'launcher_awaken', name:'卫星射线', icon:'🛰️', type:'awaken', cls:'launcher',
    desc:'5.2倍伤害+灼烧3回合+追加30%伤害', cost:50, cd:8, unlockLv:50,
    dmg:{mult:5.2}, effects:{burn:{dmg:15,dur:3},bonusHit:{chance:1.0,mult:0.30}} },
  crusader_awaken: { id:'crusader_awaken', name:'天启之珠', icon:'✨', type:'awaken', cls:'crusader',
    desc:'3.5倍伤害+全队ATK/DEF+50%持续3回合', cost:50, cd:8, unlockLv:50,
    dmg:{mult:3.5}, effects:{buff:[{stat:'atk',val:0.50,dur:3,relative:true},{stat:'def',val:0.50,dur:3,relative:true}]} },
  monk_awaken: { id:'monk_awaken', name:'泯灭神击', icon:'👊', type:'awaken', cls:'monk',
    desc:'5.8倍伤害，HP越低伤害越高(最高+1.5x)', cost:50, cd:8, unlockLv:50,
    dmg:{mult:5.8,hpScaling:{perPct:0.10,bonusPerPct:0.15,maxMult:7.3}}, effects:{} },
};
